<template>
  <surveys-grid :type="1" :items="polls" :page-title="pageTitle" @refresh="refresh"
                return-page="polls"
                empty-text="Brak ankiet"/>
</template>

<script>
import {mapActions, mapState} from "vuex";
import PageTitle from "@/mixins/pageTitle";
import BeforeRoute from "@/mixins/beforeRoute";
import SurveysGrid from "@/components/quiz/SurveysGrid";

export default {
  name: "PollsPage",
  components: {SurveysGrid},
  mixins: [
    BeforeRoute('fetchPolls'),
    PageTitle('Ankiety'),
  ],
  methods: {
    ...mapActions([
      'fetchUser',
      'fetchPolls'
    ]),
    refresh() {
      this.fetchPolls();
      this.fetchUser();
    },
  },
  computed: {
    ...mapState({
      polls: state => state.polls.polls,
    }),
  }
}
</script>

<style scoped>

</style>
